export interface ParsedItemDetails {
  weaponName: string;
  skinName: string;
  condition: string;
}

export const parseItemDetails = (fullName: string): ParsedItemDetails => {
  const specialPrefix = fullName.startsWith('Sealed Graffiti')
    ? 'Graffiti'
    : fullName.startsWith('Sticker')
      ? 'Sticker'
      : null;

  if (specialPrefix) {
    const parts = fullName.split('|');
    let pattern = specialPrefix;
    let color = '';
    if (parts.length >= 2) {
      const rightPart = parts[1].trim();
      const match = rightPart.match(/^(.+?)\s*\((.+?)\)$/);
      if (match) {
        pattern = match[1].trim();
        color = match[2].trim();
      } else {
        pattern = rightPart;
      }
    }
    return { weaponName: specialPrefix, skinName: pattern, condition: color };
  }

  const caseMatch = fullName.match(/^(.+?)\s+(Case|Capsule|Package|Collection)$/i);
  if (caseMatch) {
    return { weaponName: caseMatch[2], skinName: caseMatch[1], condition: '' };
  }

  const nameWithoutPrefixes = fullName
    .replace(/^★\s*/, '')
    .replace(/^StatTrak™\s+/, '')
    .replace(/^Souvenir\s+/, '')
    .trim();

  const parts = nameWithoutPrefixes.split(' | ');
  if (parts.length < 2) {
    return { weaponName: nameWithoutPrefixes, skinName: '', condition: '' };
  }

  const weaponName = parts[0].trim();
  const skinWithWear = parts[1].trim();
  const wearMatch = skinWithWear.match(/\((.*?)\)$/);
  const condition = wearMatch ? wearMatch[1] : '';
  const skinName = condition ? skinWithWear.replace(/\s*\([^)]*\)\s*$/, '').trim() : skinWithWear;

  return { weaponName, skinName, condition };
};
